import React from "react";
import { Instagram, Youtube, Music2 } from "lucide-react";
import { formatFollowers } from "@/lib/api";

export const PLATFORM_META = {
  instagram: { label: "Instagram", Icon: Instagram, color: "text-rose-500" },
  tiktok: { label: "TikTok", Icon: Music2, color: "text-zinc-900" },
  youtube: { label: "YouTube", Icon: Youtube, color: "text-red-600" },
};

export function SocialRow({ platform, account }) {
  const meta = PLATFORM_META[platform];
  if (!meta) return null;
  const { Icon, label, color } = meta;
  return (
    <div className="flex items-center gap-2 text-sm">
      <Icon className={`h-4 w-4 ${color}`} />
      <span className="font-medium text-zinc-700">{label}</span>
      <span className="ml-auto font-mono font-semibold text-zinc-900">
        {formatFollowers(account.followers)}
      </span>
    </div>
  );
}
